import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { SignupSSOTermsInfo } from "~/components/Modals/SignupModal/SignupSSOTermsInfo";
export const SignUpModalFooter = /*#__PURE__*/ memo((param)=>{
    let { onLoginClick } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ _jsx(SignupSSOTermsInfo, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-center text-14 text-pigeon-600",
                        children: "Already have an account?"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "text-14 font-medium text-jay-500 hover:underline",
                        onClick: onLoginClick,
                        children: "Log in"
                    })
                ]
            })
        ]
    });
});
SignUpModalFooter.displayName = "SignUpModalFooter";
